import _bounceOut from "./bounce-out";
var exports = {};
var bounceOut = _bounceOut;

function bounceInOut(t) {
  return t < 0.5 ? 0.5 * (1 - bounceOut(1 - t * 2)) : 0.5 * bounceOut(t * 2 - 1) + 0.5;
}

exports = bounceInOut;
export default exports;